import r from '../Utils/fetch';

const w: any = window;
const endPoint = `${w.API_BILLING_URL}`;

export interface IBillingAccount {
	id: number;
}

// deleteBillingAccount supprime un BA en cascade (projets, connector_accounts,
// datasets BQ manages, subs, entitlements, etc.). Reserve aux admins Quanti
// (ROLE_ADMIN JWT).
// ⚠️ Le customer Stripe est SUPPRIME lui aussi (customer.Del), apres annulation
// de ses abonnements vivants. Les factures passees restent lisibles dans Stripe,
// mais plus rien ne les rattache au compte.
export const deleteBillingAccount = (billingAccountId: string): Promise<any> =>
	r({
		url: `${endPoint}/v1/admin/billing-accounts/${billingAccountId}`,
		method: 'DELETE',
	});

// setBillingAccountFreeFlag marque (ou non) un compte comme compte de test :
// demo, essai interne. Purement declaratif — aucun droit, aucune facturation
// n'en depend. Sert a retrouver ces comptes, notamment au nettoyage.
// setBillingAccountAgentsBeta ouvre (ou ferme) la beta des agents IA sur un compte :
// allowlist lue par api-agents, en plus du produit Ask AI.
export const setBillingAccountAgentsBeta = (
	billingAccountId: string,
	enabled: boolean
): Promise<any> =>
	r({
		url: `${endPoint}/v1/admin/billing-accounts/${billingAccountId}/agents-beta`,
		method: 'PUT',
		data: { enabled },
	});

export const setBillingAccountFreeFlag = (
	billingAccountId: string,
	isFree: boolean
): Promise<any> =>
	r({
		url: `${endPoint}/v1/admin/billing-accounts/${billingAccountId}/free-account`,
		method: 'PUT',
		data: { isFree },
	});

export const BENCHMARK_ENABLED = 'enabled',
	BENCHMARK_DISABLED = 'disabled',
	BENCHMARK_INHERIT = 'inherit';

export const benchmarkTypeChoices = [
	{ id: BENCHMARK_ENABLED, name: BENCHMARK_ENABLED },
	{ id: BENCHMARK_DISABLED, name: BENCHMARK_DISABLED },
	{ id: BENCHMARK_INHERIT, name: BENCHMARK_INHERIT },
];

// Un BA est actif s'il a au moins une subscription Stripe active ou en trialing.
// Les subs actives sont preload depuis le backend (FindAll).
export const isBillingAccountActive = (record: any): boolean =>
	Array.isArray(record?.subscriptions) && record.subscriptions.length > 0;

export const currencies = [
	{ id: 'EURO', name: '€' },
	{ id: 'DOLLAR', name: '$' },
];

export const countryChoices = [
	{ id: 'US', name: 'United States' },
	{ id: 'CA', name: 'Canada' },
	{ id: 'GB', name: 'United Kingdom' },
	{ id: 'FR', name: 'France' },
	{ id: 'DE', name: 'Germany' },
	{ id: 'IT', name: 'Italy' },
	{ id: 'ES', name: 'Spain' },
	{ id: 'JP', name: 'Japan' },
	{ id: 'CN', name: 'China' },
	{ id: 'IN', name: 'India' },
	{ id: 'BR', name: 'Brazil' },
	{ id: 'AU', name: 'Australia' },
	{ id: 'MX', name: 'Mexico' },
	{ id: 'RU', name: 'Russia' },
	{ id: 'ZA', name: 'South Africa' },
	{ id: 'KR', name: 'South Korea' },
	{ id: 'AR', name: 'Argentina' },
	{ id: 'CH', name: 'Switzerland' },
	{ id: 'SE', name: 'Sweden' },
	{ id: 'NL', name: 'Netherlands' },
];

// ---- Compte Entreprise (hors Stripe) ----

export interface IEnterpriseAccountInput {
	name: string
	organisationName?: string
	siren?: string
	vat?: string
	adress?: string
	zipCode?: string
	city?: string
	country?: string
	billEmail?: string
	signFirstname?: string
	signLastname?: string
	signEmail?: string
	signPhone?: string
	ownerEmail: string
	products: Array<{ product: string; quantity: number }>
}

export interface IEnterpriseAccountResult {
	billingAccount: { id: string; name: string }
	products: any[]
	invitationError?: string
}

/** Crée un compte Entreprise : droits en lignes contrat, propriétaire invité par email. */
export const createEnterpriseBillingAccount = (input: IEnterpriseAccountInput): Promise<IEnterpriseAccountResult> =>
	r({ url: `${endPoint}/v1/admin/billing-accounts`, method: 'POST', data: input })
